import {ReactElement} from 'react';
import Head from 'next/head';
import {usePageMetadata} from 'mkt-ssr/lib/page/metadata';
import {Preconnect} from 'mkt-ssr/components/Preconnect';
import {GlobalizedAlternates} from 'mkt-ssr/components/GlobalizedAlternates/GlobalizedAlternates';
import {Favicons} from 'mkt-ssr/components/PageHead/Favicons';
import {SocialMetaTags} from 'mkt-ssr/components/PageHead/SocialMetaTags';

/**
 * Html head and some metadata for mkt-ssr pages
 */
export const PageHead = (): ReactElement | null => {
  const pageMetadata = usePageMetadata();
  const unindexed = pageMetadata.seo?.indexed === false;

  if (!pageMetadata) return null;

  return (
    <>
      <Head>
        <title>{pageMetadata.analytics.title}</title>
        {unindexed ? <meta name="robots" content="noindex, nofollow" /> : null}
      </Head>
      <Preconnect />
      <GlobalizedAlternates />
      <Favicons />
      <SocialMetaTags />
      <meta name="format-detection" content="telephone=no" />
    </>
  );
};
